import { cn } from "../../lib/utils.ts";
import { IconMark } from "./icons.tsx";

export interface WaxSealProps {
  size?: number;
  tone?: "gold" | "lime";
  /** Play the stamp-in animation (the "seal-and-send" moment). */
  stamped?: boolean;
  className?: string;
}

/**
 * The brand emblem — the coupe mark embossed inside a dashed wax-seal ring.
 * Reused on Welcome, the loading state, and the signature send moment.
 */
export function WaxSeal({ size = 96, tone = "gold", stamped, className }: WaxSealProps) {
  const accent = tone === "lime" ? "var(--lime-500)" : "var(--gold-500)";
  const ringAlpha = tone === "lime" ? "oklch(86% 0.18 120 / 35%)" : "oklch(79% 0.12 80 / 35%)";
  const dashAlpha = tone === "lime" ? "oklch(86% 0.18 120 / 30%)" : "oklch(79% 0.12 80 / 30%)";
  return (
    <div className={cn("relative", stamped && "jod-seal-in", className)} style={{ color: accent }}>
      <div
        className="absolute"
        style={{
          inset: -16,
          background:
            tone === "lime"
              ? "radial-gradient(circle, oklch(86% 0.18 120 / 18%), transparent 68%)"
              : "radial-gradient(circle, var(--amber-glow), transparent 68%)",
          filter: "blur(8px)",
        }}
        aria-hidden="true"
      />
      <div
        className="relative grid place-items-center rounded-full"
        style={{
          width: size,
          height: size,
          background: "radial-gradient(circle at 50% 32%, oklch(24% 0.02 60), oklch(15% 0.012 58))",
          border: `1px solid ${ringAlpha}`,
          boxShadow: "var(--shadow-card)",
        }}
      >
        <div
          className="absolute rounded-full"
          style={{ inset: 8, border: `1px dashed ${dashAlpha}` }}
          aria-hidden="true"
        />
        <IconMark size={size * 0.4} />
      </div>
    </div>
  );
}
